// Premium görünüm için özel JavaScript - Güncellenmiş Versiyon

// Sayfa yüklendiğinde yumuşak geçiş efekti
document.addEventListener('DOMContentLoaded', function() {
  document.body.classList.add('animate-page');
  
  // Animasyonlu elementleri işaretle
  const sections = document.querySelectorAll('.rich-text, .multicolumn, .image-with-text, .featured-collection');
  sections.forEach(section => {
    section.classList.add('animate-on-scroll');
  });
  
  // Sayfa kaydırma animasyonu
  checkAnimations();
  window.addEventListener('scroll', checkAnimations);
  
  // Ürün kartlarını düzenle
  enhanceProductCards();
  
  // Header ikonlarını geliştir
  enhanceHeaderIcons();
});

// Animasyonları kontrol et
function checkAnimations() {
  const elements = document.querySelectorAll('.animate-on-scroll');
  elements.forEach(element => {
    const position = element.getBoundingClientRect().top;
    const screenPosition = window.innerHeight / 1.3;
    
    if(position < screenPosition) {
      element.classList.add('animated');
    }
  });
}

// Ürün kartlarını geliştir
function enhanceProductCards() {
  // Ürün kartlarını seç
  const productCards = document.querySelectorAll('.card-wrapper');
  
  productCards.forEach(card => {
    // Ürün görsellerini düzenle
    const productImage = card.querySelector('.card__media img');
    if (productImage) {
      productImage.style.transition = 'transform 0.5s ease';
      
      // Hover efekti ekle
      card.addEventListener('mouseenter', function() {
        productImage.style.transform = 'scale(1.05)';
      });
      
      card.addEventListener('mouseleave', function() {
        productImage.style.transform = 'scale(1)';
      });
    }
    
    // Ürün başlıklarını düzenle
    const productTitle = card.querySelector('.card__heading');
    if (productTitle) {
      productTitle.style.marginTop = '10px';
    }
  });
}

// Header ikonlarını geliştir
function enhanceHeaderIcons() {
  // Header ikonlarını seç
  const cartIcon = document.querySelector('.header__icon--cart');
  const accountIcon = document.querySelector('.header__icon--account');
  const searchIcon = document.querySelector('.header__icon--search');
  
  // İkonlara animasyon ekle
  [cartIcon, accountIcon, searchIcon].forEach(icon => {
    if (icon) {
      icon.style.transition = 'transform 0.3s ease, box-shadow 0.3s ease';
      
      icon.addEventListener('mouseenter', function() {
        this.style.transform = 'translateY(-2px)';
        this.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
      });
      
      icon.addEventListener('mouseleave', function() {
        this.style.transform = 'translateY(0)';
        this.style.boxShadow = 'none';
      });
    }
  });
}

// Ürün görsellerinde hover zoom efekti
function setupProductImageZoom() {
  const productImages = document.querySelectorAll('.product__media img');
  productImages.forEach(image => {
    image.addEventListener('mouseover', function() {
      this.style.transform = 'scale(1.05)';
      this.style.transition = 'transform 0.3s ease';
    });
    
    image.addEventListener('mouseout', function() {
      this.style.transform = 'scale(1)';
    });
  });
}

// Ürün sayfalarında zoom efektini etkinleştir
if (document.querySelector('.product__media')) {
  setupProductImageZoom();
}

// Sepete ekleme animasyonu
const addToCartButtons = document.querySelectorAll('button[name="add"]');
addToCartButtons.forEach(button => {
  button.addEventListener('click', function() {
    // Orijinal butonu sakla
    const originalText = this.innerHTML;
    
    // Yükleniyor animasyonu göster
    this.innerHTML = '<span class="loading-spinner"></span> Ekleniyor...';
    
    // Animasyon tamamlandıktan sonra orijinal butonu geri getir
    setTimeout(() => {
      this.innerHTML = originalText;
    }, 1500);
  });
});

// Sticky header
const header = document.querySelector('.header');
let lastScrollTop = 0;

window.addEventListener('scroll', function() {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
  if (scrollTop > 100) {
    header.classList.add('header--sticky');
    
    if (scrollTop > lastScrollTop) {
      // Aşağı kaydırma
      header.classList.add('header--hidden');
    } else {
      // Yukarı kaydırma
      header.classList.remove('header--hidden');
    }
  } else {
    header.classList.remove('header--sticky');
    header.classList.remove('header--hidden');
  }
  
  lastScrollTop = scrollTop;
});
